/** @jsx jsx */
import { css, jsx } from '@emotion/core';
export const MainContent = ({ animationUrl, imageSrc, className }) => {
  return (
    <div
      className={className}
      css={css`
        width: 100%;
        & > * {
          width: 100%;
          max-height: 500px;
          outline: none;
        }
      `}
    >
      {animationUrl ? (
        <video id="token-video" controls autoplay loop muted>
          <source src={animationUrl} type="video/mp4" />
          Your browser does not support playing videos.
        </video>
      ) : (
        <img src={imageSrc} alt="Token" />
      )}
    </div>
  );
};
